<template>
  <div class="portfolio">
    <div class="thumbs">
      <div
        v-for="(item, index) in images" :key=index
        v-show="(index<(pageDisplayed * imagesPerPage + (imagesPerPage))&&index >= (pageDisplayed*imagesPerPage))"
        class="img-container"
      >
        <img :src="item.thumb" @click="setIndexToShow(index)"/>
      </div>
      <div v-if="showEmpty(1)" class="img-container"></div>
      <div v-if="showEmpty(2)" class="img-container"></div>
      <div class="nav">
        <div v-bind:class="[isActive('left'), 'nav-left']" @click="navigate('left')">&lt;&lt;</div>
        <div v-bind:class="[isActive('right'), 'nav-right']" @click="navigate('right')">&gt;&gt;</div>
      </div>
    </div>
    <div class="content">
      <div v-if="indexToShow > -1 && indexToShow < images.length">
        <div class="content-container">
          <div class="p-nav p-nav-l">
            <div v-bind:class="[isActiveP('left',images[indexToShow].images.length), 'nav-left', 'nav-circle']" @click="navigateP('left',images[indexToShow].images.length)">
              <a href="#">
                <span class="circle left"></span>
              </a>
            </div>
            <!--<div v-bind:class="[isActive('left'), 'nav-left', 'nav-circle']" @click="navigateP('left',images[indexToShow].images.length)">&lt;&lt;</div>-->
          </div>
          <div
            v-for="(image, index) in renderImages(indexToShow)" :key=index
            v-show="index == imageDisplayed"
            class="content-img"
          >
            <img :src="image" />
          </div>
          <div class="p-nav p-nav-r">
            <div v-bind:class="[isActiveP('right',images[indexToShow].images.length), 'nav-right', 'nav-circle']" @click="navigateP('right', images[indexToShow].images.length)">
              <a href="#">
                <span class="circle right"></span>
              </a>
            </div>
            <!--<div v-bind:class="[isActive('right'), 'nav-right', 'nav-circle']" @click="navigateP('right', images[indexToShow].images.length)">&gt;&gt;</div>-->
          </div>
        </div>
        <div class="no-of-images content-text">
          <span v-for="(item, index) in images[indexToShow].images" v-bind:class="[(index==imageDisplayed)?'active':'not-active','dot']" :key=index>
          </span>

        </div>
        <div class="content-text">{{images[indexToShow].title}}</div>
      </div>
      <div v-else>
        To view my works, click on the small pictures to the left. The arrows below the images will help you navigate trough my portfolio
      </div>
    </div>
  </div>
</template>

<script>
import portfolio from '../data/Portfolio'
export default {
  name: 'Portfolio',
  data () {
    return {
      imagesPerPage: 3,
      pageDisplayed: 0,
      indexToShow: -1,
      imageDisplayed: 0,
      images: []
    }
  },
  created () {
    this.images = portfolio.get()
  },
  methods: {
    //
    isActive (dir) {
      switch (dir) {
        case 'left':
          if (this.pageDisplayed > 0) {
            return 'active'
          } else {
            return 'not-active'
          }
        case 'right':
          if (((this.pageDisplayed * this.imagesPerPage) + this.imagesPerPage) > this.images.length) {
            return 'not-active'
          } else {
            return 'active'
          }
      }
    },
    showEmpty (nr) {
      var nrOfEmpty = (this.imagesPerPage * this.pageDisplayed + this.imagesPerPage) - this.images.length
      if (nrOfEmpty >= nr) {
        return true
      }
    },
    setIndexToShow (index) {
      if (this.images.length > index + 1) {
        this.indexToShow = index
        this.imageDisplayed = 0
      } else {
        this.indexToShow = -1
      }
    },
    renderImages (index) {
      return this.images[index].images
    },
    navigate (dir) {
      switch (dir) {
        case 'left':
          if (this.pageDisplayed > 0) {
            this.pageDisplayed--
            this.imageDisplayed = 0
          }
          break
        case 'right':
          if (((this.pageDisplayed * this.imagesPerPage) + this.imagesPerPage) < this.images.length) {
            this.pageDisplayed++
            this.imageDisplayed = 0
          }
          break
      }
    },
    navigateP (dir, max) {
      switch (dir) {
        case 'left':
          if (this.imageDisplayed > 0) {
            this.imageDisplayed--
          }
          break
        case 'right':
          if (this.imageDisplayed < (max - 1)) {
            this.imageDisplayed++
          }
          break
      }
    },
    isActiveP (dir, max) {
      switch (dir) {
        case 'left':
          if (this.imageDisplayed > 0) {
            return 'active'
          } else {
            return 'not-active'
          }
        case 'right':
          if (this.imageDisplayed >= (max - 1)) {
            return 'not-active'
          } else {
            return 'active'
          }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/styles/_variables.scss';

$portfolio-height:250px;

h4 {
  margin-bottom: 0.2em;
  margin-top: 0em;
}
.portfolio {
  margin-top:$box-margin-top;
}
.thumbs{
  float:left;
  width: $sidebar-width;
}
.nav {
  width: calc(100%-40px);
  padding: 20px;
}
.nav > .not-active {
  color:#bbb;
  cursor: default;
}

.nav > .active {
  cursor: pointer;
}

.nav-left {
  float:left;
}
.nav-right {
  float:right;
}

.content{
  width:$content-width;
}
.content-container {
  display: flex;
}

.content-img{
  min-width: calc(#{$content-width} - 100px);
  max-width: calc(#{$content-width} - 100px);
  height: $portfolio-height;
  margin: auto;
  text-align: center;
}
.content-img img {
  max-width: 100%;
  max-height: 100%;
  box-shadow: 5px 5px 3px grey;
}
.content-text{
  text-align:center;
  width: $content-width;
  margin-top: 20px;
  margin-right:20px;
}
.content-text{
  text-align:center;
  width: $content-width;
  margin-top: 10px;
}
.content-nav {
  float:right;
  width: 50px;
  margin-top: 20px;
}
.p-nav {
  min-width: 40px;
  padding-top: calc((#{$portfolio-height} / 2) - 1em);
}
.p-nav-left {
  float: left;
}
.p-nav-right {
  float: right;
}

.img-container {
  width:86px;
  height:65px;
  padding: 10px 5px;
}
.menu > li {
  margin-bottom: 15px;
  text-align: left;
  list-style: none;
  cursor: pointer;
}

.menu > li:hover {
  border-bottom: 2px solid $acc-color;
  margin-bottom: 13px;
}
.content {
    float: right;
    width: 490px;
    text-align: left;
    display: block;
    /* overflow: scroll; */
    max-height: 330px;
    scroll-behavior: smooth;
    overflow-y: auto;
    overflow-x: hidden;
    font-size: 0.9em;
}
.content-block{
  margin-bottom: 0.4em;
}

.nav-circle {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
}

.not-active .circle {
  border-color:lightgray!important;
  cursor: default;
}
.not-active .circle:after {
  border-color:lightgray!important;
  cursor: default;
}

.nav-circle > a {
  display: inline-block;
  border-radius: 50%;
}

.nav-circle a:hover .left, a:hover .top, a:hover .bottom, a:hover .right{
  border: 0.35em solid #42b983;
}

.nav-circle a:hover .left:after, a:hover .top:after, a:hover .bottom:after, a:hover .right:after {
  border-top: 0.35em solid #42b983;
  border-right: 0.35em solid #42b983;
}

.circle {
  display: inline-block;
  width: 2em;
  height: 2em;
  border: 0.35em solid #333;
  border-radius: 50%;
}
.circle:after {
  content: '';
  display: inline-block;
  margin-top: 0.45em;
  width: 0.8em;
  height: 0.8em;
  border-top: 0.35em solid #333;
  border-right: 0.35em solid #333;
}

.left:after {
  margin-left: 0.6em;
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
  -moz-transform: rotate(-135deg);
}

.right:after {
  margin-left: 0.2em;
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
.dot {
  height: 10px;
  width: 10px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  margin: 0 4px;
}
.not-active.dot {
  background-color: #333;
}
a {
  color: #42b983;
}
</style>
